export const styles = {
  titlePaper: {
    textAlign: "left",
    fontWeight: "400",
    color: "#b2b2b2",
    fontSize: "2em"
  },
  selectBig: {
    fontSize: "32px",
    marginTop:"20px",
    display: "block"
  },
  max800: {
    maxWidth: "800px"
  },
  paper: {
    padding: "1em",
    textAlign: 'center',
    whiteSpace: 'nowrap',
    margin: "1em",
    background: "#fff",
    position: "relative",
  },
  paperIcon: {
    padding: "1em 1em 1em 3em",
    textAlign: 'center',
    whiteSpace: 'nowrap',
    margin: "1em",
    background: "#fff",
    position: "relative"
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: "1em",
    flex: "1",
    color: "#FFF"
  },
  fav: {
    borderRadius: "100%",
    height: "60px",
    width: "60px",
    minWidth: "60px",
    float: "right",
    marginRight: "20px"
  },
  buttonRight: {
    minWidth: "40px",
    padding: "8px"
  },
  inputBig: {
    fontSize: "30px"
  },
  iconLeft: {
    height: "40px",
    width: "40px",
    position: "absolute",
    left: "20px",
    top: "20px",
    opacity: "0.5"
  },
  iconLeftBig: {
    height: "40px",
    width: "40px",
    position: "absolute",
    left: "20px",
    top: "40px",
    opacity: "0.5"
  },
  itemIcon: {
     width: "100",
     color: "#b2b2b2",
     height: "100"
  },
  listItem: {
    paddingLeft: "0"
  }
};



// WEBPACK FOOTER //
// ./src/components/ExportarPesajeCsv/ExportarPesajeStyle.js